import { Combobox, Listbox, Transition } from "@headlessui/react";
import { CheckIcon, ChevronUpDownIcon } from "@heroicons/react/24/solid";
import React, { useEffect } from "react";
import { Fragment, useState } from "react";
import { OptionProps } from "./SbModel";
import { Film } from 'lucide-react';


interface SelectComboboxProps {
  id: string;
  options: OptionProps[];
  initialValue: OptionProps;
  onChange: (value: OptionProps) => void;
  disabled?: boolean;
  placeholder?: string;
  showFilmIcon?: boolean;
}

const SelectCombobox: React.FC<SelectComboboxProps> = ({
  id,
  options,
  initialValue,
  onChange,
  disabled = false,
  placeholder = "Select an option",
  showFilmIcon = false,
}) => {
  const [query, setQuery] = useState('');
  const [selectedOption, setSelectedOption] = useState<OptionProps>({ id: '', name: '' });

  useEffect(() => {
    console.log('options', options);
    setSelectedOption(initialValue);
  }, [initialValue]);

  function classNames(...classes) {
    return classes.filter(Boolean).join(' ');
  }
  const filteredOptions =
    query === ''
      ? options
      : options.filter((option: OptionProps) => {
        return option.name.toLowerCase().includes(query.toLowerCase());
      });
  return (
    <>
      <Combobox
        value={selectedOption}
        onChange={(value: any) => {
          setSelectedOption(value);
          onChange(value);
        }}
        disabled={disabled}
      >
        <div className="relative w-full" id={id}>
          <Combobox.Button className="relative w-full">
            {showFilmIcon && (
              <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                <Film className="h-5 w-5 text-gray-400" aria-hidden="true" />
              </div>
            )}
            <Combobox.Input
              className={`w-full rounded-md border border-gray-300 bg-white py-2 pl-${showFilmIcon ? '10' : '3'} pr-10 text-left shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm ${disabled ? 'bg-gray-100 cursor-not-allowed' : 'cursor-pointer'
                }`}
              displayValue={(option: OptionProps) => option?.name || ''}
              onChange={(event) => setQuery(event.target.value)}
              placeholder={placeholder}
              readOnly
            />
            <div className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
              <ChevronUpDownIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
            </div>
          </Combobox.Button>
          <Transition
            as={Fragment}
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
            afterLeave={() => setQuery('')}
          >
            <Combobox.Options
              id={'ul_' + id}
              className="absolute z-20 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
            >
              {filteredOptions.length === 0 && query !== '' ? (
                <div className="relative cursor-default select-none px-4 py-2 text-gray-700">
                  Nothing found.
                </div>
              ) : (
                filteredOptions.map((option) => (
                  <Combobox.Option
                    key={option.id}
                    className={({ active }) =>
                      classNames(
                        'relative cursor-default select-none py-2 pl-10 pr-4',
                        active ? 'bg-blue-200 text-black' : 'text-gray-700'
                      )
                    }
                    value={option}
                  >
                    {({ selected, active }) => (
                      <>
                        <span className={`block truncate ${selected ? 'font-medium' : 'font-normal'}`}>
                          {option.name}{option.role ? ` (${option.role})` : ''}
                        </span>
                        {selected ? (
                          <span
                            className={`absolute inset-y-0 left-0 flex items-center pl-3 ${active ? 'text-white' : 'text-teal-600'
                              }`}
                          >
                            <CheckIcon className="h-5 w-5" aria-hidden="true" />
                          </span>
                        ) : null}
                      </>
                    )}
                  </Combobox.Option>
                ))
              )}
            </Combobox.Options>
          </Transition>
        </div>
      </Combobox>
    </>
  );
};
export default SelectCombobox;
